import { change } from 'redux-form';

import { cancelBooking as mutation } from '../../../lib/graphql';
import getAllBookings from "../../../components/Booking/BookingList/getAllBookings.graphql";
import query from '../../../routes/site-admin/viewBooking/viewBookingDetails.graphql';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { closeCancelBookingModal, closeCancelScheduledBookingModal } from '../modalActions';

export default function cancelBooking(variables) {

    try {
        return async (dispatch, getState, { client }) => {

            dispatch(change("CancelBookingForm", "loading", true));

            const { data } = await client.mutate({
                mutation,
                variables,
                refetchQueries: [{ query, variables: { id: variables.bookingId } }, { query: getAllBookings, variables: { currentPage: variables?.currentPage || 1, bookingType: 1 } }]
            });
            if (data?.cancelBooking?.status == 200) {
                showToaster({ messageId: 'cancelBooking', toasterType: 'success' });
            } else {
                showToaster({ messageId: 'errorMessage', requestContent: data?.cancelBooking?.errorMessage, toasterType: 'error' });
            }

            dispatch(change("CancelBookingForm", "loading", false));
            variables?.status !== 'scheduled' ? dispatch(closeCancelBookingModal()) :
                dispatch(closeCancelScheduledBookingModal());
            return true;
        }
    } catch (error) {
        dispatch(change("CancelBookingForm", "loading", false));
        showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
    }
}
